import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Checkbox } from "../../../../components/Checkbox/Checkbox";
import { FormField } from "../../../../components/Form";
import styles from "../../CommonContactForm.module.scss";
import checkboxStyles from "./FormCheckbox.module.scss";
export const FormCheckbox = ({ id, label, isCheckedByDefault, validationRules, dataTestId = "formCheckbox", }) => {
    return (_jsx(FormField, { dataTestId: dataTestId, className: classNames(styles.formField, checkboxStyles.formField, checkboxStyles.checkboxContainer), id: id, name: id, showCustomError: true, validation: {
            validate: (value) => (validationRules.required ? !!value?.checked : true),
        }, render: ({ field, fieldState: { error } }) => (_jsx(Checkbox, { ...field, id: id, labelHtml: label, defaultChecked: isCheckedByDefault, isError: !!error, errorText: error?.message, isHelperTextVisible: true })) }));
};
//# sourceMappingURL=FormCheckbox.js.map